export const COST_TYPES = Object.freeze({
  AMOUNT: 'Amount',
  TABLE_LOOKUP: 'Table Lookup',
  API_CALC: 'API Calculation',
});
